import { Select, SelectItem } from "@heroui/react";

const SpeakerSelect = ({ speakers, selectedKeys, onSelectionChange }) => (
  <Select
    classNames={{
      label: "group-data-[filled=true]:-translate-y-5 text-black text-base",
      popoverContent: "w-80",
      trigger: "min-h-16 bg-transparent shadow-none w-40",
      listboxWrapper: "bg-transparent w-80",
    }}
    items={speakers}
    label="Sprecher"
    selectionMode="multiple"
    selectedKeys={selectedKeys}
    onSelectionChange={onSelectionChange}
  >
    {(speaker) => (
      <SelectItem key={speaker.key}>{speaker.label}</SelectItem>
    )}
  </Select>
);

export default SpeakerSelect;
